/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Recipes_HelpInputs */

const en_shopping_recipes_help = /** @type {(inputs: Shopping_Recipes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not planned for a day: their ingredients stay on the list whatever the range, until you take them off.`)
};

const de_shopping_recipes_help = /** @type {(inputs: Shopping_Recipes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Tag eingeplant: Ihre Zutaten bleiben auf der Liste, egal welcher Zeitraum, bis du sie herausnimmst.`)
};

/**
* | output |
* | --- |
* | "Not planned for a day: their ingredients stay on the list whatever the range, until you take them off." |
*
* @param {Shopping_Recipes_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_recipes_help = /** @type {((inputs?: Shopping_Recipes_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Recipes_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_recipes_help(inputs)
	return en_shopping_recipes_help(inputs)
});